const Citation = ({citation}) => {
    if(!citation || citation.length === 0) return <></>;
    return (
        <>
            <span className="citation">{`\n(${citation.course ? 'Course ' + citation.course + ' ' : '' }${citation.sourceType}${citation.title ? ' - ' + citation.title : ''})`}</span>
        </>
    )
}

export default Citation;